import { Component, Inject, ChangeDetectionStrategy, inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormGroup, FormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { emailValidator } from "src/app/shared/email-validator.directive";
import { NewsletterService } from "src/app/services/newsletter.service";
import { I18nService } from "src/app/services/i18n.service";

// « Me désinscrire » sans lien sous la main : l'API envoie le lien de désinscription à l'adresse
// (on ne désinscrit plus directement une adresse saisie, n'importe qui pouvait le faire pour autrui)
@Component({
    selector: 'dialog-content-newsletter-disable',
    templateUrl: 'dialog-content-newsletter-disable.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogContentNewsLetterDisable {

  form!: FormGroup;
  loading = false;
  sent = false;
  error = '';

  private i18n = inject(I18nService);

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { email?: string },
    public dialogRef: MatDialogRef<DialogContentNewsLetterDisable>,
    private newsLetterService: NewsletterService
  ) {
    this.form = this.fb.group({
      email: new UntypedFormControl(data?.email || '', [Validators.required,
        Validators.minLength(1),
        Validators.maxLength(250),
        emailValidator()]),
    });
  }

  submit() {
    if (this.form.invalid || this.loading) {
      return;
    }
    this.loading = true;
    this.error = '';
    this.newsLetterService.requestUnsubscribeLink(this.form.value.email).subscribe({
      next: () => {
        this.loading = false;
        this.sent = true;
      },
      error: err => {
        this.loading = false;
        this.error = err || this.i18n.t('common.errorOccurred');
      }
    });
  }
}
